import React from "react";
import {TextInput} from "admin-on-rest";
import EmbeddedArrayInput from "../../../../../components/CRM/EmbeddedArrayInput";
import {required} from "../../validations";
import {formStyle} from "../../style";

class V86form extends React.Component {
  render() {
    return (
      <EmbeddedArrayInput
        label="Bet list"
        source="bet_lines"
        numberOfFields="8"
        allowAdd={true}
        allowRemove={false}
        insertDividers={false}
        innerContainerStyle={formStyle.arrayInput.innerContainerStyle}
        labelContainerStyle={formStyle.arrayInput.labelContainerStyle}
      >
        <TextInput
          label=""
          source="horses"
          validate={required}
          elStyle={formStyle.textInput.horsesStyle}
        />
        <TextInput
          label=" "
          source="reserve"
          validate={required}
          elStyle={formStyle.textInput.reserveStyle}
        />

        <div style={formStyle.clearDiv} />
      </EmbeddedArrayInput>
    );
  }
}

export default V86form;



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/TicketLayouts/V86/V86CreateForm.js